import { useOrgResolvedFlag } from './useOrgResolvedFlag';

export const CIVILDRAW_USE_NEW_DRAWING_CANVAS_FLAG = 'civildraw-use-new-drawing-canvas';

/** Whether CivilDraw maps use the new DrawingCanvas view for the current organization. */
export function useNewCivilDrawDrawingCanvas(): { resolved: boolean; enabled: boolean } {
  return useOrgResolvedFlag(CIVILDRAW_USE_NEW_DRAWING_CANVAS_FLAG);
}
